(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9602],{

/***/ 52624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(41672)


/***/ }),

/***/ 41672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(47529)
var defaults = __webpack_require__(29370)

module.exports = wrapper

var own = {}.hasOwnProperty
var push = [].push

var nodeSchema = {
  root: {children: all},
  doctype: handleDoctype,
  comment: handleComment,
  element: {
    tagName: handleTagName,
    properties: handleProperties,
    children: all
  },
  text: {value: handleValue},
  '*': {data: allow, position: allow}
}

// Sanitize `node`, according to `schema`.
function wrapper(node, schema) {
  var ctx = {type: 'root', children: []}
  var replace

  if (node && typeof node === 'object' && node.type) {
    replace = one(xtend(defaults, schema || {}), node, [])

    if (replace) {
      if ('length' in replace) {
        if (replace.length === 1) {
          ctx = replace[0]
        } else {
          ctx.children = replace
        }
      } else {
        ctx = replace
      }
    }
  }

  return ctx
}

// Sanitize `node`.
function one(schema, node, stack) {
  var type = node && node.type
  var replacement = {type: node.type}
  var replace
  var definition
  var allowed
  var result
  var key

  if (own.call(nodeSchema, type)) {
    definition = nodeSchema[type]

    if (typeof definition === 'function') {
      definition = definition(schema, node)
    }

    if (definition) {
      replace = true
      allowed = xtend(definition, nodeSchema['*'])

      for (key in allowed) {
        result = allowed[key](schema, node[key], node, stack)

        if (result === false) {
          replace = null
          // Set the non-safe value.
          replacement[key] = node[key]
        } else if (result != null) {
          replacement[key] = result
        }
      }
    }
  }

  if (replace) {
    return replacement
  }

  return replacement.children &&
    replacement.children.length &&
    schema.strip.indexOf(replacement.tagName) < 0
    ? replacement.children
    : null
}

// Sanitize `children`.
function all(schema, children, node, stack) {
  var results = []
  var index = -1
  var value

  if (children) {
    stack.push(node.tagName)

    while (++index < children.length) {
      value = one(schema, children[index], stack)

      if (value) {
        if ('length' in value) {
          push.apply(results, value)
        } else {
          results.push(value)
        }
      }
    }

    stack.pop()
  }

  return results
}

// Sanitize `properties`.
function handleProperties(schema, properties, node, stack) {
  var name = handleTagName(schema, node.tagName, node, stack)
  var reqs = schema.required || /* istanbul ignore next */ {}
  var props = properties || {}
  var allowed = xtend(
    toPropertyValueMap(schema.attributes['*']),
    toPropertyValueMap(
      own.call(schema.attributes, name) ? schema.attributes[name] : []
    )
  )
  var result = {}
  var definition
  var key
  var value

  for (key in props) {
    if (own.call(allowed, key)) {
      definition = allowed[key]
    } else if (data(key) && own.call(allowed, 'data*')) {
      definition = allowed['data*']
    } else {
      continue
    }

    value = props[key]
    value =
      value && typeof value === 'object' && 'length' in value
        ? handlePropertyValues(schema, value, key, definition)
        : handlePropertyValue(schema, value, key, definition)

    if (value != null) {
      result[key] = value
    }
  }

  if (own.call(reqs, name)) {
    for (key in reqs[name]) {
      if (!own.call(result, key)) {
        result[key] = reqs[name][key]
      }
    }
  }

  return result
}

// Sanitize a property value which is a list.
function handlePropertyValues(schema, values, prop, definition) {
  var result = []
  var index = -1
  var value

  while (++index < values.length) {
    value = handlePropertyValue(schema, values[index], prop, definition)

    if (value != null) {
      result.push(value)
    }
  }

  return result
}

// Sanitize a property value.
function handlePropertyValue(schema, value, prop, definition) {
  if (
    (typeof value === 'boolean' ||
      typeof value === 'number' ||
      typeof value === 'string') &&
    handleProtocol(schema, value, prop) &&
    (!definition.length || definition.indexOf(value) > -1)
  ) {
    return schema.clobber.indexOf(prop) < 0
      ? value
      : schema.clobberPrefix + value
  }
}

// Check whether `value` is a safe URL.
function handleProtocol(schema, value, prop) {
  var url = String(value)
  var colon = url.indexOf(':')
  var questionMark = url.indexOf('?')
  var numberSign = url.indexOf('#')
  var slash = url.indexOf('/')
  var protocols = own.call(schema.protocols, prop)
    ? schema.protocols[prop].concat()
    : []
  var index = -1

  if (
    !protocols.length ||
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign)
  ) {
    return true
  }

  while (++index < protocols.length) {
    if (
      colon === protocols[index].length &&
      url.slice(0, protocols[index].length) === protocols[index]
    ) {
      return true
    }
  }

  return false
}

// Always return a valid HTML5 doctype.
function handleDoctypeName() {
  return 'html'
}

// Sanitize `tagName`.
function handleTagName(schema, tagName, node, stack) {
  var name = typeof tagName === 'string' && tagName
  var index = -1

  if (!name || name === '*' || schema.tagNames.indexOf(name) < 0) {
    return false
  }

  // Some nodes can break out of their context if they don’t have a certain
  // ancestor.
  if (own.call(schema.ancestors, name)) {
    while (++index < schema.ancestors[name].length) {
      if (stack.indexOf(schema.ancestors[name][index]) > -1) {
        return name
      }
    }

    return false
  }

  return name
}

function handleDoctype(schema) {
  return schema.allowDoctypes ? {name: handleDoctypeName} : null
}

function handleComment(schema) {
  return schema.allowComments ? {value: handleCommentValue} : null
}

// See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
function handleCommentValue(schema, value) {
  var result = typeof value === 'string' ? value : ''
  var index = result.indexOf('-->')

  return index < 0 ? result : result.slice(0, index)
}

// Sanitize `value`.
function handleValue(schema, value) {
  return typeof value === 'string' ? value : ''
}

// Create a map from a list of props or a list of properties and values.
function toPropertyValueMap(values) {
  var result = {}
  var index = -1
  var value

  while (++index < values.length) {
    value = values[index]

    if (value && typeof value === 'object' && 'length' in value) {
      result[value[0]] = value.slice(1)
    } else {
      result[value] = []
    }
  }

  return result
}

// Allow `value`.
function allow(schema, value) {
  return value
}

// Check if `prop` is a data property.
function data(prop) {
  return prop.length > 4 && prop.slice(0, 4).toLowerCase() === 'data'
}


/***/ }),

/***/ 60250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ContentPageBody; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(29387);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(70178);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/rehype-raw/index.js
var rehype_raw = __webpack_require__(76388);
var rehype_raw_default = /*#__PURE__*/__webpack_require__.n(rehype_raw);
// EXTERNAL MODULE: ./node_modules/rehype-sanitize/index.js
var rehype_sanitize = __webpack_require__(1667);
var rehype_sanitize_default = /*#__PURE__*/__webpack_require__.n(rehype_sanitize);
// EXTERNAL MODULE: ./components/styleguide/NewsletterWidget/index.ts + 1 modules
var NewsletterWidget = __webpack_require__(22705);
// EXTERNAL MODULE: ./components/views/ContentPageBody/content-page-body.module.scss
var content_page_body_module = __webpack_require__(17188);
var content_page_body_module_default = /*#__PURE__*/__webpack_require__.n(content_page_body_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./lib/utilities/content.ts
var getAverageReadTime = function(numberOfWords) {
    var averageWordsPerMinute = 225;
    return Math.ceil(numberOfWords / averageWordsPerMinute);
};

// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/ContentPageBody/ContentPageBody.js



















var ContentPageBody = function(param) {
    var article = param.article;
    dayjs_min_default().extend((utc_default()));
    dayjs_min_default().extend((timezone_default()));
    var customSanitize = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (rehype_sanitize_default())), {
            tagNames: [
                "div",
                "p",
                "a",
                "h1",
                "h2",
                "h3",
                "ul",
                "li"
            ],
            attributes: {
                "*": [
                    "class",
                    "id",
                    "href"
                ],
                a: [
                    "target",
                    "rel"
                ],
                div: [
                    "class"
                ]
            }
        });
    }, []);
    var flattenImages = function(children) {
        if (children && children[0] && children.length === 1 && children[0].props && children[0].props.src) {
            var ref = children[0], imgEl = ref.props;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (content_page_body_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: imgEl.src,
                    alt: imgEl.alt,
                    width: 1320,
                    height: 742
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "".concat((content_page_body_module_default()).content, " ").concat((content_page_body_module_default()).paragraph),
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((content_page_body_module_default()).content, " ").concat((content_page_body_module_default()).header),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (content_page_body_module_default()).title,
                        children: article.content.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (content_page_body_module_default()).meta,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).author),
                                children: [
                                    "By ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog/authors",
                                        children: article.content.author
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).ellipse)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (content_page_body_module_default()).item,
                                children: [
                                    getAverageReadTime(article.content.body.toString().split(" ").length),
                                    " min read"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).ellipse)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (content_page_body_module_default()).item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                    dateTime: dayjs_min_default()(article.content.pubDate).tz("Europe/London").format(),
                                    children: dayjs_min_default()(article.content.pubDate).tz("Europe/London").format(constants/* constants.blogDateFormat */._G.blogDateFormat)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterWidget/* NewsletterWidget */.X, {
                        location: "blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((content_page_body_module_default()).description, " ").concat((content_page_body_module_default()).paragraph),
                        children: article.content.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (content_page_body_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: article.content.thumbnail,
                    alt: article.content.thumbnailAlt,
                    width: 1320,
                    height: 742.5
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (content_page_body_module_default()).article,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                    components: {
                        p: function p(param) {
                            var children = param.children;
                            return flattenImages(children);
                        },
                        br: function br() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // removes break tags
                            ;
                        },
                        h1: function h1() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // removes duplicate h1s
                            ;
                        },
                        h2: function h2(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (content_page_body_module_default()).h2,
                                children: children
                            });
                        },
                        h3: function h3(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (content_page_body_module_default()).h3,
                                children: children
                            });
                        },
                        h4: function h4(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (content_page_body_module_default()).h4,
                                children: children
                            });
                        },
                        ul: function ul(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (content_page_body_module_default())["unordered-list"],
                                children: children
                            });
                        },
                        a: function a(param) {
                            var href = param.href, children = param.children;
                            var text = Array.isArray(children) ? children[0] : children;
                            var targetAttr = "";
                            var classAttr = "";
                            var attributeMatch = text.match(/{:.*?}/);
                            if (attributeMatch) {
                                var attributes = attributeMatch[0].replace(/{:|}/g, "").trim().replace(/&quot;/g, '"');
                                var targetMatch = attributes.match(/target="([^"]+)"/);
                                if (targetMatch) {
                                    targetAttr = targetMatch[1];
                                }
                                var classMatch = attributes.match(/class="([^"]+)"/);
                                if (classMatch) {
                                    classAttr = classMatch[1];
                                }
                                text = text.replace(attributeMatch[0], "").trim();
                            }
                            if (classAttr === "button") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                    size: system/* Size.Large */.$u.Large,
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                    href: href,
                                    hasPadding: true,
                                    hasBackground: true,
                                    target: targetAttr || undefined,
                                    className: (content_page_body_module_default())[classAttr],
                                    children: text
                                });
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: href,
                                target: targetAttr || undefined,
                                className: (content_page_body_module_default())[classAttr] || undefined,
                                children: text
                            });
                        }
                    },
                    rehypePlugins: [
                        (rehype_raw_default()),
                        customSanitize
                    ],
                    children: article.content.body.replace(/:::cta/g, '<div class="'.concat((content_page_body_module_default())["cta-block"], '">')).replace(/:::/g, "</div>")
                })
            }),
            !article && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert alert-warning mt-3",
                role: "alert",
                children: "We've had trouble finding this blog post. Please try again later."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/ContentPageBody/index.js



/***/ }),

/***/ 17188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unordered-list":"content-page-body_unordered-list__KAqgH","content":"content-page-body_content__1clwf","h2":"content-page-body_h2__UTuDK","h3":"content-page-body_h3__hIOxQ","h4":"content-page-body_h4__W3yRg","cta-block":"content-page-body_cta-block__teM27","header":"content-page-body_header__6bzpI","title":"content-page-body_title__ouJiU","paragraph":"content-page-body_paragraph__wPS1w","button":"content-page-body_button__ugRPf","article":"content-page-body_article__ws_9L","meta":"content-page-body_meta__vqfgi","item":"content-page-body_item__oTC_x","ellipse":"content-page-body_ellipse__0NwRU","author":"content-page-body_author__XorJV","image":"content-page-body_image__8pGk3","phAnimation":"content-page-body_phAnimation__d_AMI"};

/***/ }),

/***/ 1667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var clean = __webpack_require__(52624)

module.exports = sanitize

function sanitize(options) {
  return transformer
  function transformer(tree) {
    return clean(tree, options)
  }
}


/***/ }),

/***/ 29370:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto","xmpp","irc","ircs"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details","caption","figure","figcaption","abbr","bdo","cite","dfn","mark","small","span","time","wbr","input"],"attributes":{"a":["href"],"img":["src","longDesc"],"input":[["type","checkbox"],["disabled",true]],"li":[["className","task-list-item"]],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","ariaDescribedBy","ariaHidden","ariaLabel","ariaLabelledBy","axis","border","cellPadding","cellSpacing","char","charOff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hSpace","isMap","id","label","lang","maxLength","media","method","multiple","name","noHref","noShade","noWrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","vAlign","value","vSpace","width","itemProp"]},"required":{"input":{"type":"checkbox","disabled":true}}}');

/***/ })

}]);